import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Order matters: fonts declare the @font-face rules, then tokens define the
// variables that base.css and every component module reference.
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';

import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
